import React from 'react';
import Icon from '../../../components/AppIcon';

const AboutSection = ({ channelData }) => {
  return (
    <div className="about-section">
      <div className="section-header mb-6">
        <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
          О канале
        </h2>
      </div>
      <div className="about-content space-y-6">
        <div className="about-card bg-card rounded-lg border border-border p-6">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="FileText" size={20} color="var(--color-primary)" />
            Описание
          </h3>
          <p className="text-sm text-foreground leading-relaxed whitespace-pre-line">
            {channelData?.fullDescription}
          </p>
        </div>

        <div className="about-card bg-card rounded-lg border border-border p-6">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Tag" size={20} color="var(--color-primary)" />
            Темы и категории
          </h3>
          <div className="flex flex-wrap gap-2">
            {channelData?.tags?.map((tag, index) => (
              <span
                key={index}
                className="px-3 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-caption"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="about-card bg-card rounded-lg border border-border p-6">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Award" size={20} color="var(--color-primary)" />
            Достижения
          </h3>
          <div className="space-y-3">
            {channelData?.achievements?.map((achievement, index) => (
              <div key={index} className="achievement-item flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center">
                  <Icon name="Trophy" size={20} color="var(--color-warning)" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-heading font-medium text-foreground mb-1">
                    {achievement?.title}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {achievement?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="about-card bg-card rounded-lg border border-border p-6">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Info" size={20} color="var(--color-primary)" />
            Дополнительная информация
          </h3>
          <div className="space-y-3">
            <div className="info-item flex justify-between items-center">
              <span className="text-sm text-muted-foreground">Дата создания канала</span>
              <span className="text-sm font-mono text-foreground">
                {new Date(channelData.createdDate)?.toLocaleDateString('ru-RU', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric'
                })}
              </span>
            </div>
            <div className="info-item flex justify-between items-center">
              <span className="text-sm text-muted-foreground">Язык контента</span>
              <span className="text-sm font-mono text-foreground">{channelData?.language}</span>
            </div>
            <div className="info-item flex justify-between items-center">
              <span className="text-sm text-muted-foreground">Частота выхода</span>
              <span className="text-sm font-mono text-foreground">{channelData?.frequency}</span>
            </div>
            <div className="info-item flex justify-between items-center">
              <span className="text-sm text-muted-foreground">Локация</span>
              <span className="text-sm font-mono text-foreground">{channelData?.location}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;